import deleteWithToken from './base/delete-with-token'

const customerDeleteAction = (id, data) => deleteWithToken(`/customer-timeline/action/${id}`)(data)

export default customerDeleteAction